import { createSlice } from '@reduxjs/toolkit';

const selectedWalletSlice = createSlice({
  name: 'wallet_info',
  initialState: {},
  reducers: {
    selectedWalletReducer: {
      reducer: (state, action) => (state = action.payload),
      prepare: (value) => ({ payload: value || [] }),
    },
  },
});

export const { selectedWalletReducer } = selectedWalletSlice.actions;
export default selectedWalletSlice.reducer;